<div class="dataLoading" *ngIf="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div *ngIf="!dataLoading">
  <div class="crud-list-wrapper">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="main-title">{{ 'meetings.Recommendations' | translate }}</h4>
    </div>
    <div class="crud-list-container">
      <div class="crud-list">
        <div cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let item of recordsData.pageData; index as i;" class="crud-control" cdkDrag
            [ngClass]='{"loading black": recommendsDeleteId == item.id, "mt-0": i == 0}'>
            <span class="drag-me" cdkDragHandle>
              <img src="./assets/images/icons/drag-drop-icon.svg" alt="">
            </span>
            <span class="list-icon">
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path id="listing-icon"
                  d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                  fill="#aaa" />
              </svg>
            </span>
            <div>
              <div class="form-control">{{item.recommendation}}</div>
            </div>
            <div class="actions">
              <button class="btn" *ngIf="item.canDelete" (click)="deleteRecord(item.id)">
                <img alt="" src="./assets/images/icons/delete-icon.svg">
              </button>
            </div>
          </div>

          <div class="crud-control" *ngIf="recordsData.canAdd" [ngClass]='{"loading black": itemLoading}'>
            <span class="drag-me">
              <img src="./assets/images/icons/drag-drop-icon.svg" alt="">
            </span>
            <span class="list-icon">
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path id="listing-icon"
                  d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                  fill="#aaa" />
              </svg>
            </span>
            <div>
              <textarea class="form-control" maxlength="250" cdkTextareaAutosize cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5" [placeholder]="'meetings.AddRecommendation' | translate"
                (keydown.enter)="addListItem($event)" [(ngModel)]="listItem" [ngModelOptions]="{standalone: true}"
                maxlength="250"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!recordsData.canAdd && !recordsData.pageData.length">
      <div class="data-empty no-bg h-100">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="110" height="99.999"
          viewBox="0 0 110 99.999">
          <defs>
            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#469595" />
              <stop offset="1" stop-color="#0b7ebc" />
            </linearGradient>
            <linearGradient id="linear-gradient-2" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#469595" />
              <stop offset="1" stop-color="#14374D" />
            </linearGradient>
          </defs>
          <g id="no-members-illustration" transform="translate(-823 -642)">
            <path id="Path_2516" data-name="Path 2516"
              d="M99.268,21.663c0,22.014,11.315,37.132,11.315,47.74s-6.051,32.886-54.471,32.886S.583,72.318.583,60.65c0-54.637,98.685-77.975,98.685-38.987Z"
              transform="translate(822.417 639.71)" fill="#efefef" opacity="0.6" />
            <g id="Group_764" data-name="Group 764" transform="translate(839.484 647.141)">
              <path id="Path_2517" data-name="Path 2517" d="M0,0H6.365V3.183H0Z"
                transform="translate(12.941 4.508) rotate(-45)" fill="#9fbfcf" />
              <path id="Path_2518" data-name="Path 2518" d="M0,0H6.365V3.183H0Z"
                transform="translate(0 17.443) rotate(-45)" fill="#9fbfcf" />
              <path id="Path_2519" data-name="Path 2519" d="M0,0H3.183V6.365H0Z"
                transform="translate(0.562 2.25) rotate(-45)" fill="#9fbfcf" />
            </g>
            <path id="shadow"
              d="M37.154,11.75H29A7.247,7.247,0,0,0,21.75,19v4.531H29.9V19A7.247,7.247,0,0,1,37.154,11.75Z"
              transform="translate(870.018 657.366)" fill="#d5dbe1" />
            <path id="Union_1" data-name="Union 1"
              d="M-431.043,7160.122v-3.544a5.338,5.338,0,0,0-5.347-5.315h-10.7a5.338,5.338,0,0,0-5.347,5.315v3.544a1.778,1.778,0,0,1-1.783,1.771,1.777,1.777,0,0,1-1.783-1.771v-3.544a8.9,8.9,0,0,1,8.913-8.859h10.7a8.9,8.9,0,0,1,8.911,8.859v3.544a1.776,1.776,0,0,1-1.781,1.771A1.777,1.777,0,0,1-431.043,7160.122Zm-17.827-23.035a7.116,7.116,0,0,1,7.13-7.087,7.116,7.116,0,0,1,7.13,7.087,7.117,7.117,0,0,1-7.13,7.089A7.117,7.117,0,0,1-448.87,7137.087Zm3.566,0a3.557,3.557,0,0,0,3.564,3.544,3.559,3.559,0,0,0,3.566-3.544,3.558,3.558,0,0,0-3.566-3.543A3.557,3.557,0,0,0-445.3,7137.087Z"
              transform="translate(1346.478 -6480.998)" fill="url(#linear-gradient)" />
            <path id="shadow-2" data-name="shadow"
              d="M14.909,36.413A22.658,22.658,0,0,1,33.492,14.134a22.656,22.656,0,1,0-4.079,44.941,22.879,22.879,0,0,0,4.079-.384A22.658,22.658,0,0,1,14.909,36.413Z"
              transform="translate(831.25 662.25)" fill="#d5dbe1" />
            <path id="Union_2" data-name="Union 2"
              d="M-398.49,7189.673l-16.121-16.021a24.937,24.937,0,0,1-16.432,6.152A24.911,24.911,0,0,1-456,7155a24.911,24.911,0,0,1,24.958-24.8,24.911,24.911,0,0,1,24.956,24.8,24.615,24.615,0,0,1-6.017,16.137l16.135,16.032a1.768,1.768,0,0,1,0,2.506,1.781,1.781,0,0,1-1.26.518A1.792,1.792,0,0,1-398.49,7189.673ZM-452.435,7155a21.349,21.349,0,0,0,21.392,21.263A21.348,21.348,0,0,0-409.652,7155a21.347,21.347,0,0,0-21.391-21.26A21.348,21.348,0,0,0-452.435,7155Zm32.088,12.211v-3.544a5.338,5.338,0,0,0-5.349-5.314h-10.7a5.338,5.338,0,0,0-5.349,5.314v3.544a1.777,1.777,0,0,1-1.781,1.772,1.777,1.777,0,0,1-1.783-1.772v-3.544a8.9,8.9,0,0,1,8.912-8.858h10.7a8.9,8.9,0,0,1,8.912,8.858v3.544a1.777,1.777,0,0,1-1.781,1.772A1.777,1.777,0,0,1-420.348,7167.209Zm-17.827-23.033a7.116,7.116,0,0,1,7.131-7.088,7.115,7.115,0,0,1,7.13,7.088,7.115,7.115,0,0,1-7.13,7.086A7.115,7.115,0,0,1-438.174,7144.176Zm3.566,0a3.557,3.557,0,0,0,3.566,3.542,3.556,3.556,0,0,0,3.564-3.542,3.557,3.557,0,0,0-3.564-3.544A3.557,3.557,0,0,0-434.609,7144.176Z"
              transform="translate(1293 -6456.192)" fill="url(#linear-gradient-2)" />
          </g>
        </svg>
      </div>
    </ng-container>

  </div>

  <app-case-voting [agendaItem]="item" [module]="VotingView.Recommend"></app-case-voting>

</div>
